export const passwordManager = {
	selectors: {
		form: '.js-password-form',
		generateButton: '.js-generate-password',
		passwordInput: '.js-password-input',
		generatedPasswordLabel: '.js-generated-password-label',
		minimalPasswordLength: '.js-password-min-length',
	},
}
